// extracted by mini-css-extract-plugin
module.exports = {"select-diagnosis-box":"select-diagnosis-box___iG1EK","name":"name___1DhGQ","select-btn":"select-btn___wlflP","remove-icon":"remove-icon___3C_bP"};